import { discoveryByGame } from "../../gamemode_management/selectors";
import { getApplication } from "../../../util/application";
import { getGame } from "../../gamemode_management/util/getGame";
import { hasLoadOrder, hasSessionPlugins } from "../utils/guards";
/**
 * Core delegates for FOMOD installer IPC communication
 * These are called by the C# installer process to query game/mod state
 */
export class SharedDelegates {
    static async create(api, gameId) {
        const delegates = new SharedDelegates(api);
        await delegates.initialize(gameId);
        return delegates;
    }
    mApi;
    mGameVersion = null;
    constructor(api) {
        this.mApi = api;
    }
    initialize = async (gameId) => {
        const state = this.mApi.getState();
        const discovery = discoveryByGame(state, gameId);
        const gameInfo = getGame(gameId);
        this.mGameVersion =
            (await gameInfo?.getInstalledVersion?.(discovery)) ?? null;
    };
    /**
     * Get the application version
     */
    getAppVersion = () => {
        try {
            return getApplication().version;
        }
        catch (error) {
            return "";
        }
    };
    /**
     * Get the current game version
     */
    getCurrentGameVersion = () => {
        try {
            return this.mGameVersion.split(/\-+/)[0];
        }
        catch (error) {
            return "";
        }
    };
    /**
     * Get the version of a script extender (e.g., SKSE, F4SE)
     */
    getExtenderVersion = (extender) => {
        try {
            return this.mGameVersion.split(/\-+/)[0];
        }
        catch (error) {
            return "";
        }
    };
    /**
     * Get all plugins (mods with .esp/.esm/.esl files)
     */
    getAllPlugins = (activeOnly) => {
        try {
            const state = this.mApi.getState();
            if (!hasSessionPlugins(state.session)) {
                return [];
            }
            const pluginList = state.session.plugins?.pluginList ?? {};
            let plugins = Object.keys(pluginList);
            if (activeOnly === true) {
                plugins = plugins.filter((name) => this.isPluginEnabled(state, pluginList, plugins, name));
            }
            return plugins;
        }
        catch (error) {
            return [];
        }
    };
    isPluginEnabled = (state, pluginList, plugins, pluginName) => {
        const existingPluginName = plugins.find((plugin) => plugin.toLowerCase() === pluginName.toLowerCase());
        if (existingPluginName === undefined) {
            // unknown plugin can't be enabled
            return false;
        }
        if (pluginList[existingPluginName].isNative) {
            return true;
        }
        if (!hasLoadOrder(state)) {
            return false;
        }
        return state.loadOrder[existingPluginName]?.enabled ?? false;
    };
}
